import { createAction, props } from '@ngrx/store';
import { CustomerIdentification } from '../../types/customer-identification';
import { OrgData } from '../../types/org-data';

export const setOrgData = createAction('[Forms] Set orgdata', props<OrgData>());

export const setCustomerIdentification = createAction(
    '[Forms] Set customer identification',
    props<{ customerIdentification: CustomerIdentification }>(),
);
export const updateCustomerIdentification = createAction(
    '[Forms] Update customer identification input field',
    props<UpdateCustomerIdentificationProps>(),
);

export type UpdateCustomerIdentificationProps = Readonly<{
    xmlId: string;
    newValue: string;
    invalidateSignatures: boolean;
}>;
